import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BelenderRoutes } from 'src/app/belender/interfaces/belender-route.interface';
import { LegalComponent } from './legal.component';
import { QuicklinkModule } from 'ngx-quicklink';

const routes: BelenderRoutes = [
  {
    path: '',
    component: LegalComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule, QuicklinkModule]
})
export class LegalRoutingModule {
}
